(function () {
  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var video = modal.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function openModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    document.querySelectorAll('.terra-sp-modal:not([hidden])').forEach(closeModal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var video = modal.querySelector('video');
    if (video) video.play().catch(function () {});
  }

  function initRoot(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-terra-sp-video-open]').forEach(function (btn) {
      if (btn.dataset.terraSpBound === 'true') return;
      btn.dataset.terraSpBound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(btn.getAttribute('data-terra-sp-video-open'));
      });
    });

    scope.querySelectorAll('[data-terra-sp-close]').forEach(function (el) {
      if (el.dataset.terraSpBound === 'true') return;
      el.dataset.terraSpBound = 'true';
      el.addEventListener('click', function () {
        var modal = el.closest('.terra-sp-modal');
        closeModal(modal);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRoot();
    });
  } else {
    initRoot();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.terra-sp-modal:not([hidden])').forEach(closeModal);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initRoot(event.target);
  });
})();
